import { useState } from "react";
import Card from "components/card";
import Skeleton from "@mui/material/Skeleton";
import { Dialog } from "@headlessui/react";
import EMPTY_ICON from "../../../assets/svg/empty.svg";
import { Tooltip } from "@mui/material";
import { Drawer } from "@mui/material";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { useMemo } from "react";
import {
  MdCancel,
  MdCheckCircle,
  MdDeleteOutline,
  MdModeEditOutline,
  MdOutlineError,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { FaRegEye } from "react-icons/fa";

import Image from "components/image";
import { RxCross2 } from "react-icons/rx";
import { deleteAccount } from "../../../redux/action/index";
import { useDispatch } from "react-redux";
import { getCookie } from "utils/cookie";
import { BiRefresh } from "react-icons/bi";
import { FiFilter } from "react-icons/fi";
import { IoAdd } from "react-icons/io5";

const AccountsTable = (props) => {
  let [isOpenViewModal, setIsOpenViewModal] = useState(false);
  let [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const navigate = useNavigate();
  const { columnsData, tableData, usersData, shimmer, image_id } = props;
  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => tableData, [tableData]);
  const [deleteId, setDeleteId] = useState("");
  const dispatch = useDispatch();
  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const userRole = getCookie("role");
  const userEmail = getCookie("email");

  const { initialState } = tableInstance;
  initialState.pageSize = 5;

  const handleDeleteAccount = (id) => {
    console.log("deleteId in function", id);
    dispatch(deleteAccount({ id: id }))
      .then((res) => {
        setIsOpenDeleteModal(false);
        props.handleGetAccounts({ skip: 0, limit: 10 });
      })
      .catch((err) => {
        console.log(err);
        setIsOpenDeleteModal(false);
      });
  };

  const openDeleteModal = () => {
    setIsOpenDeleteModal(true);
  };
  const handleApplyFilter = () => {
    props?.handleGetAccounts();
    props?.setIsDrawerOpen(false);
  };
  return (
    <Card extra={"w-full h-full p-4 sm:overflow-x-auto"}>
      <div className="relative flex items-center justify-between">
        <div className="text-xl font-bold text-navy-700 dark:text-white">
          All Accounts
        </div>
        <div className="flex gap-2">
          <button
            onClick={() => {
              props?.resetFilters();
            }}
            className="linear flex items-center justify-center gap-1 rounded-xl border border-brand-600 px-[8px] py-[10px] text-xs font-medium text-brand-600 transition duration-200 hover:bg-brand-600 hover:text-white active:bg-brand-700 disabled:cursor-not-allowed disabled:bg-gray-600 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
          >
            <BiRefresh size={18} /> Reset
          </button>
          <button
            onClick={() => props?.toggleDrawer(true)}
            className="linear flex items-center justify-center gap-1 rounded-xl border border-brand-600 px-[8px] py-[10px] text-xs font-medium text-brand-600 transition duration-200 hover:bg-brand-600 hover:text-white active:bg-brand-700 disabled:cursor-not-allowed disabled:bg-gray-600 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
          >
            <FiFilter size={15} /> Filters
          </button>
          <button
            onClick={() => {
              navigate("/admin/accounts/add-new-account");
            }}
            className="item-center linear flex justify-center gap-2 rounded-xl border border-brand-600 px-[8px] py-[10px] text-xs font-medium text-brand-600 transition duration-200 hover:bg-brand-600 hover:text-white active:bg-brand-700 disabled:cursor-not-allowed disabled:bg-gray-600 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
          >
            <IoAdd size={18} /> Add New Account
          </button>
        </div>
      </div>

      <div className="mt-8 h-full overflow-x-scroll xl:overflow-hidden">
        {shimmer && (
          <div className="w-full">
            <table className="w-full">
              <thead>
                <tr>
                  <th>
                    <Skeleton width={200} height={30} />
                  </th>
                  <th>
                    <Skeleton width={200} height={30} />
                  </th>
                  <th>
                    <Skeleton width={200} height={30} />
                  </th>
                  <th>
                    <Skeleton width={200} height={30} />
                  </th>
                  <th>
                    <Skeleton width={200} height={30} />
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                  <td>
                    <Skeleton width={200} height={30} />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}

        <div className="overflow-x-auto">
          <table className="min-w-full">
            <thead>
              <tr>
                {!shimmer &&
                  columns.map((val, index) => (
                    <th
                      className="border-b border-gray-200 pb-[10px] pr-6 text-start dark:!border-navy-700"
                      key={index}
                    >
                      <p className="text-xs tracking-wide text-gray-600">
                        {val.Header}
                      </p>
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody>
              {!shimmer &&
                usersData?.data?.length &&
                usersData?.data?.map((item, index) => {
                  // Define conditions to disable edit and delete
                  const isSameEmail = userEmail === item.email;
                  const isSameRole =
                    userRole === "admin" && item.role === "admin";
                  const canEditDelete =
                    !isSameEmail && !(isSameRole && userRole === "admin");
                  const disableEditDelete = isSameEmail || isSameRole;
                  return (
                    <tr key={index}>
                      <td className="pb-[18px] pt-[14px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {item?.s_no}
                        </p>
                      </td>
                      <td className="pb-[18px] pt-[14px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {item?.firstname} {item.lastname}
                        </p>
                      </td>

                      <td className="pb-[18px] pt-[14px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {item?.email}
                        </p>
                      </td>
                      <td className="pb-[18px] pt-[14px] sm:text-[14px]">
                        <p className="pl-[35px] text-sm font-bold text-navy-700 dark:text-white">
                          <p className={` rounded-full text-xl`}>
                            {item.verified === true ? (
                              <MdCheckCircle className="text-green-500" />
                            ) : item.verified === false ? (
                              <MdCancel className="text-red-500" />
                            ) : null}
                          </p>
                        </p>
                      </td>
                      <td className="pb-[18px] pt-[14px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {item.phone}
                        </p>
                      </td>
                      <td className="pb-[18px] pt-[14px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {item.role}
                        </p>
                      </td>
                      <td className="pb-[18px] pt-[14px] sm:text-[14px]">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {moment(item?.createdOn * 1000).format(
                            "DD MMM, YYYY - hh:mm A"
                          )}
                        </p>
                      </td>
                      <td className="pb-[18px] pt-[14px] sm:text-[14px]">
                        <div className="flex items-center gap-2">
                          <div className={`rounded-full text-xl`}>
                            {item.status === 1 ? (
                              <MdCheckCircle className="text-green-500" />
                            ) : item.status === 0 ? (
                              <MdCancel className="text-red-500" />
                            ) : item.status === 2 ? (
                              <MdOutlineError className="text-orange-500" />
                            ) : null}
                          </div>
                          <p className="text-sm font-bold text-navy-700 dark:text-white">
                            {item.status === 1
                              ? "Activated"
                              : item.status === 0
                              ? "Deactivated"
                              : item.status === 2
                              ? "Suspended"
                              : null}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div className="flex items-center gap-1">
                          {/* <div className="flex h-6 w-6 items-center justify-center rounded-full border border-brand-400 text-brand-400 hover:bg-brand-400 hover:text-white active:bg-brand-600">
                          <FaRegEye
                            size={14}
                            className="cursor-pointer "
                            onClick={() => {
                              // setMarkers(item.marker);
                              // setModalImage(item.path);
                              openViewModal();
                            }}
                          />
                        </div> */}
                          {/* 
                          <div className="flex h-6 w-6 items-center justify-center rounded-full border border-green-500 text-green-500 hover:bg-green-500 hover:text-white active:bg-green-700">
                            <MdModeEditOutline
                              size={14}
                              className="cursor-pointer "
                              onClick={() => {
                                navigate("/admin/accounts/edit-account", {
                                  state: { userData: item },
                                });
                              }}
                            />
                          </div>
                          <div className="flex h-6 w-6 items-center justify-center rounded-full border border-red-500 text-red-500 hover:bg-red-500 hover:text-white active:bg-red-700">
                            <MdDeleteOutline
                              size={14}
                              className="cursor-pointer"
                              onClick={() => {
                                openDeleteModal();
                                setDeleteId(item?.id);
                              }}
                            />
                          </div> */}
                          <Tooltip
                            title={
                              disableEditDelete
                                ? "You are not allowed to edit this account"
                                : ""
                            }
                            arrow
                            disableHoverListener={!disableEditDelete}
                          >
                            <div
                              className={`flex h-6 w-6 items-center justify-center rounded-full ${
                                canEditDelete
                                  ? "cursor-pointer border border-green-500 text-green-500 hover:bg-green-500 hover:text-white"
                                  : "cursor-not-allowed border border-gray-500 opacity-50"
                              }`}
                            >
                              <MdModeEditOutline
                                size={14}
                                className=""
                                onClick={() =>
                                  canEditDelete &&
                                  navigate("/admin/accounts/edit-account", {
                                    state: { userData: item },
                                  })
                                }
                              />
                            </div>
                          </Tooltip>
                          <Tooltip
                            title={
                              disableEditDelete
                                ? "You are not allowed to delete this account"
                                : ""
                            }
                            arrow
                            disableHoverListener={!disableEditDelete}
                          >
                            <div
                              className={`flex h-6 w-6 items-center justify-center rounded-full ${
                                canEditDelete
                                  ? "cursor-pointer border border-red-500 text-red-500 hover:bg-red-500 hover:text-white"
                                  : "cursor-not-allowed border border-gray-500 opacity-50"
                              }`}
                            >
                              <MdDeleteOutline
                                size={14}
                                onClick={() => {
                                  if (canEditDelete) {
                                    setDeleteId(item?.id);
                                    openDeleteModal();
                                  }
                                }}
                              />
                            </div>
                          </Tooltip>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              {!shimmer && !usersData?.data?.length ? (
                <tr>
                  <td colSpan={8}>
                    <div className="w-100 my-5 flex items-center justify-center p-5">
                      <div className="flex flex-col items-center justify-center">
                        <Image
                          src={EMPTY_ICON}
                          alt="Empty Data"
                          width="60px"
                          height="60px"
                        />
                        <h3 className="mt-2 text-xl font-medium text-[#A3AED0]">
                          No Data Found!
                        </h3>
                      </div>
                    </div>
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>

        <Dialog
          open={isOpenDeleteModal}
          onClose={() => setIsOpenDeleteModal(false)}
          className="relative z-50"
        >
          {/* The backdrop, rendered as a fixed sibling to the panel container */}
          <div
            className="bg-black/30 fixed inset-0 h-full w-full"
            aria-hidden="true"
            style={{ backgroundColor: "rgba(0,0,0,0.3)" }}
          />
          {/* Full-screen container to center the panel */}
          <div className="fixed inset-0 flex w-screen items-center justify-center">
            {/* The actual dialog panel */}
            <Dialog.Panel className="flex w-full justify-center">
              <div className="relative w-[500px] rounded-[10px] bg-white p-6 shadow-lg">
                <button
                  className="text-black item-center absolute right-[16px] top-[15px] z-10 flex h-[21px] w-[21px] justify-center rounded-full bg-gray-200 hover:bg-gray-300"
                  onClick={() => setIsOpenDeleteModal(false)}
                >
                  <RxCross2 className="m-auto" size={14} />
                </button>

                {/* Title */}
                <h2 className="mb-4 text-center text-xl font-semibold">
                  Confirm Account Deletion
                </h2>

                {/* Confirmation Message */}
                <p className="mb-6 text-center text-gray-600">
                  Are you sure you want to delete this account? This action
                  cannot be undone.
                </p>

                {/* Buttons */}
                <div className="flex justify-center space-x-4">
                  <button
                    className="rounded-md bg-gray-200 px-4 py-2 text-gray-700 hover:bg-gray-300"
                    onClick={() => setIsOpenDeleteModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="rounded-md bg-red-600 px-4 py-2 text-white hover:bg-red-700"
                    onClick={() => handleDeleteAccount(deleteId)}
                  >
                    Delete Account
                  </button>
                </div>
              </div>
            </Dialog.Panel>
          </div>
        </Dialog>
        {/* Drawer for Filters */}
        <Drawer
          anchor="right"
          open={props?.isDrawerOpen}
          onClose={() => props?.toggleDrawer(false)}
        >
          <div style={{ width: 400, padding: "20px" }}>
            <h3 className="mb-3 font-semibold text-brand-600">Filters</h3>

            {/* search */}
            <div className="mb-2">
              <label className="mb-1 block text-sm font-medium text-gray-900 dark:text-white">
                Search<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="Search in username and email"
                value={props?.search}
                onChange={(e) => {
                  props?.setSearch(e.target.value);
                }}
                className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm"
              />
            </div>
            {/* Start Date */}
            <div className="mb-2">
              <label className="mb-1 block text-sm font-medium text-gray-900 dark:text-white">
                Start Date
              </label>
              <input
                type="date"
                value={props?.startDate}
                onChange={(e) => {
                  const selectedStartDate = e.target.value;
                  props?.setStartDate(selectedStartDate);

                  // If the selected end date is less than the start date, reset the end date
                  if (props?.endDate && selectedStartDate > props?.endDate) {
                    props?.setEndDate("");
                  }
                }}
                className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm"
                max={props?.endDate} // The start date can't be later than the selected end date
              />
            </div>

            {/* End Date */}
            <div className="mb-2">
              <label className="mb-1 block text-sm font-medium text-gray-900 dark:text-white">
                End Date
              </label>
              <input
                type="date"
                value={props?.endDate}
                onChange={(e) => {
                  const selectedEndDate = e.target.value;
                  props?.setEndDate(selectedEndDate);
                }}
                disabled={!props?.startDate} // Disable end date until start date is selected
                min={props?.startDate} // The end date can't be earlier than the start date
                className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm"
              />
            </div>

            {/*Sort */}
            <div className="mb-2">
              <label className="mb-1 block text-sm font-medium text-gray-900 dark:text-white ">
                Sort
              </label>
              <select
                id="sort"
                value={props?.sort}
                onChange={(e) => {
                  props?.setSort(e.target.value);
                }}
                className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm disabled:cursor-not-allowed disabled:border-[#CBD5E0] disabled:bg-[#FAFAFA]"
              >
                <option value="" className="text-gray-500">
                  Select Sort
                </option>
                <option value="1">Ascending</option>
                <option value="-1">Descending</option>
              </select>
            </div>

            {/* Account Status */}
            <div className="mb-2">
              <label className="mb-1 block text-sm font-medium text-gray-900 dark:text-white ">
                Account Status
              </label>
              <select
                id="accountStatus"
                value={props?.status}
                onChange={(e) => {
                  props?.setStatus(e.target.value);
                }}
                className="block w-full rounded-lg border border-gray-300 p-2.5 text-sm disabled:cursor-not-allowed disabled:border-[#CBD5E0] disabled:bg-[#FAFAFA]"
              >
                <option value="" className="text-gray-500">
                  Select Account Status
                </option>
                <option value="0">Deactivated</option>
                <option value="1">Activated</option>
                <option value="2">Suspended</option>
              </select>
            </div>

            <button
              type="button"
              style={{
                width: "100%",
                padding: "10px",
                backgroundColor: "#3f51b5",
                color: "white",
                border: "none",
                cursor: "pointer",
              }}
              className={`linear mt-3 w-1/4 rounded-xl bg-brand-500 py-[12px] text-base  text-white disabled:bg-gray-400`}
              onClick={() => {
                handleApplyFilter();
              }}
            >
              Apply Filters
            </button>
          </div>
        </Drawer>
      </div>
    </Card>
  );
};

export default AccountsTable;
